<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 4146 4146"
       xmlns:xlink="http://www.w3.org/1999/xlink">
   <g id="Vrstva_x0020_1">
    <circle class="fil0" cx="2073" cy="2073" r="2073"/>
     <path class="fil1"
           d="M2132 2111c0,-132 135,-147 135,11 0,114 -135,125 -135,-11zm-932 -975l0 2156c0,66 88,49 162,49 50,0 55,-44 55,-81 -6,-673 0,-1369 0,-2042 52,-13 63,-3 103,-1l64 -5c23,0 31,4 44,5l65 -5c23,0 30,4 44,5l64 -5c23,0 30,4 44,5l64 -5c23,0 31,4 44,5l70 -5c27,0 24,5 49,6 0,120 -5,733 4,803 4,30 -4,31 -3,52 8,278 4,561 4,840 19,5 139,89 165,106 29,20 51,36 80,56 29,19 53,35 81,54l243 163c13,9 26,17 39,27 45,34 70,22 162,22 26,0 48,-22 48,-49l0 -2156c0,-65 -65,-135 -130,-135l-1435 0c-64,0 -130,71 -130,135z"/>
   </g>
  </svg>
</template>

<script>
export default {
  name: 'DoorDevice',
};
</script>

<style scoped>
.fil1 {
  fill: #FEFEFE
}

.fil0 {
  fill: #56D6D1
}
</style>
